<template>
  <div :class="screenType">
    <!--菜单栏-->
    <div class="menuBox" :style="{position:position,background:menuData.background}">
      <template v-if="screenType === 'pc'">
        <div class="leftBox">
          <el-image :src="menuData.menuIcon" class="menuIcon " fit="contain" @click="handleOpenMenu"/>
          <div class="menuTip SourceHanSansCN-Normal" @click="handleOpenMenu">菜单</div>
        </div>
        <div class="middleBox" v-if="contentImageUrl">
          <el-image :src="fileUrl+ contentImageUrl" :class="['menuLogo', contentImageUrl ? 'opacity1' : 'opacity0']"
                    fit="contain"
                    @click="handleBackHome" v-if="!financialCalculationIconsState && financialCalculationIconsFlag"/>
          <template v-else>
            <el-image
                v-if="brandFinancialLogo && financialCalculationIconsIndex !== ''"
                :src="fileUrl+ brandFinancialLogo"
                :class="['financialCalculationIcons fadeIn','financialCalculationIcons'+financialCalculationIconsIndex]"
                fit="contain"
                @click="handleBackHome"/>
          </template>
        </div>
        <div class="rightBox">
          <div class="menuOpeartion menuOpeartion1 SourceHanSansCN-Medium" @click="handleOnlineApply">在线申请</div>
          <div class="menuOpeartion SourceHanSansCN-Medium" @click="handleLoanCalculation">贷款测算</div>
        </div>
      </template>

      <template v-if="screenType === 'mobile' && contentMobileImageUrl">
        <div class="logoBox fadeIn" v-if="position === 'absolute'">
          <el-image
              :src="fileUrl+ contentMobileImageUrl"
              class="menuLogo"
              :class="[contentImageUrl ? 'opacity1' : 'opacity0']"
              fit="contain"
              @click="handleBackHome"
              v-if="!financialCalculationIconsState && financialCalculationIconsFlag"/>
          <template v-else>
            <!--,financialCalculationIconsIndex === '6'  ? 'opacity0' : ''-->
            <el-image
                v-if="brandFinancialLogo  && financialCalculationIconsIndex !== ''"
                :src="fileUrl+ brandFinancialLogo"
                :class="['financialCalculationIcons fadeIn','financialCalculationIcons'+financialCalculationIconsIndex]"
                fit="contain"
                @click="handleBackHome"/>
          </template>


        </div>
        <div class="operationBox" v-if="isShowOperation">
          <div class="opBox" @click="handleOpenMenu">
            <el-image :src="m_menu_icon" class="m_menu_icon" fit="contain"></el-image>
            <div class="menuTip SourceHanSansCN-Normal">菜单</div>
          </div>
          <div class="rightBox">
            <div class="menuOpeartion menuOpeartion1 SourceHanSansCN-Medium" @click="handleMobileOnlineApply">在线申请
            </div>
            <div class="menuOpeartion SourceHanSansCN-Medium" @click="handleLoanCalculation">贷款测算</div>
          </div>
        </div>
      </template>
    </div>

    <template v-if="screenType === 'pc'">
      <!--:style="{height:maskHeight + 'px'}"-->
      <!--@click="handleHideMask"-->
      <!--  显示菜单栏-->
      <div class="menuMaskBigContainer" v-if="menuData.menuFlag" @click="handleHideMask">
        <div class="menuMaskContainer ">
          <div class="menuMaskBox">
            <div
                :class="['menuMc',item.active ? 'menuMc1' : '']"
                v-for="(item,index) in menuData.menuList"
                :key="index"
                @click.stop="handleSelectMenu(index)"
                @mouseover="handleMenuMouseOver(index,item)">
              <div class="menuInfo SourceHanSansCN-Regular">{{ item.name }}</div>
              <el-image :src="menuData.arrow" class="arrow" fit="contain"></el-image>
            </div>
          </div>
          <el-image :src="closeIcon" class="closeIcon" @click.stop="handleHideMask"></el-image>
        </div>
      </div>

      <!--子菜单-->
      <div class="childMaskContainer fadeIn" :style="{top:menuData.menuList[menuData.menuIndex].top+'px'}"
           v-if="menuData.childFlag" @click="handleHideMask" @mouseleave="handleChildMenuLeave">
        <div
            class="childInfoBox"
            :class="item.active ? 'active' : ''"
            v-for="(item,index) in menuData.menuList[menuData.menuIndex].data"
            :key="index"
            @click.stop="handleChildMenuClick(index,item)"
            @mouseover="handleChildMenuMouseOver(index)">
          <div class="cBox">
            <div class="childInfo">{{ item.name }}</div>
            <el-image :src="menuData.arrow" class="arrow" fit="contain"></el-image>
          </div>
        </div>
      </div>

      <!--孙子菜单栏-->
      <div
          class="sunMaskContainer fadeIn"
          v-if="menuData.sunFlag && menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data.length > 0"
          :style="{top:menuData.menuList[menuData.menuIndex].data[menuData.childIndex].top+'px'}"
          @mouseover="handleSunMouseOver"
          @mouseleave="handleSunMouseLeave">
        <div class="sunInfoBox"
             v-for="(item,index) in menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data" :key="index"
             @click.stop="handleSunMenuMouseOver(index,item)">
          <div class="sBox">
            <div class="sunInfo">{{ item.name }}</div>
            <el-image :src="menuData.arrow" class="arrow" fit="contain"></el-image>
          </div>
        </div>
      </div>

      <!--  孙子菜单-->
      <!--<div class="sunTzuBigMenuContainer" v-if="menuData.sunFlag && menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data.length > 0">-->
      <!--  <div class="sunTzuMenuContainer">-->
      <!--    <div class="sBox" v-for="(item,index) in menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data"-->
      <!--         @click.stop="handleSunMenuMouseOver(index)">-->
      <!--      <div :class="['sunTitleBox SourceHanSansCN-Regular',item.active ? 'active' : '']">{{ item.name }}</div>-->
      <!--      <div class="sunLine"></div>-->
      <!--    </div>-->
      <!--  </div>-->
      <!--</div>-->
    </template>

    <template v-if="screenType === 'mobile' && mFlag">
      <div class="mobileBigPopBox">
        <div class="mobilePopBox slideRight" v-if="menuData.menuFlag">
          <div class="mobileHeaderBox">
            <div class="m_close_box" @click.stop="handleMClose">
              <el-image :src="m_close_icon" class="m_close_icon"></el-image>
            </div>
          </div>

          <!--父菜单-->
          <div class="mobileNavBox">
            <div class="mobileNavInfo" v-for="(item,index) in menuData.menuList" :key="index"
                 @click.stop="handleMParent(index,item)">
              <div class="mNavInfo">{{ item.name }}</div>
              <el-image :src="m_right_icon" class="m_right_icon"></el-image>
            </div>
          </div>

          <!--<div class="mobileNavBox" v-if="menuData.childFlag">-->
          <!--  <div class="mobileNavInfo mobileNavInfo2" v-for="(item,index) in menuData.menuList[menuData.menuIndex].data"-->
          <!--       :key="index">-->
          <!--    <div class="mobileChildInfo" @click.stop="handleMChild(index,item)">-->
          <!--      <div class="mNavInfo">{{ item.name }}</div>-->
          <!--      <el-image :src="item.active ? m_down_icon  : m_right_icon"-->
          <!--                :class="[item.active  ? 'm_down_icon': 'm_right_icon']"></el-image>-->
          <!--    </div>-->
          <!--    <div-->
          <!--        class="mobileSunInfo"-->
          <!--        @click.stop="handleMSun(cindex,cItem)"-->
          <!--        v-if="item.active  && menuData.menuList[menuData.menuIndex].data.length > 0 && menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data.length > 0"-->
          <!--        v-for="(cItem,cindex) in menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data"-->
          <!--        :key="cindex">-->
          <!--      {{ cItem.name }}-->
          <!--    </div>-->
          <!--  </div>-->
          <!--</div>-->
        </div>

        <div class="mobilePopBox " :class="[menuData.childFlag ? 'slideLeft' : '']" v-if="menuData.childFlag">
          <div class="mobileHeaderBox mobileHeaderBox2">
            <div class="m_left_box" @click="handleMPrev">
              <el-image :src="m_left_icon" class="m_left_icon"></el-image>
            </div>
            <div class="mHeaderContent">{{ menuData.menuList[menuData.menuIndex].name }}</div>
            <div class="m_close_box" @click.stop="handleMClose">
              <el-image :src="m_close_icon" class="m_close_icon"></el-image>
            </div>
          </div>
          <div class="mobileNavBox">
            <div class="mobileNavInfo" v-for="(item,index) in menuData.menuList[menuData.menuIndex].data" :key="index"
                 @click.stop="handleMChild(index,item)">
              <div class="mNavInfo">{{ item.name }}</div>
              <el-image :src="m_right_icon" class="m_right_icon"></el-image>
            </div>
          </div>
        </div>

        <div class="mobilePopBox" :class="menuData.sunFlag ? 'slideLeft' : ''" v-if="menuData.sunFlag">
          <div class="mobileHeaderBox mobileHeaderBox2">
            <div class="m_left_box" @click="handleMSunPrev">
              <el-image :src="m_left_icon" class="m_left_icon"></el-image>
            </div>
            <div class="mHeaderContent">{{
                menuData.menuList[menuData.menuIndex]['data'][menuData.childIndex].name
              }}
            </div>
            <div class="m_close_box" @click.stop="handleMClose">
              <el-image :src="m_close_icon" class="m_close_icon"></el-image>
            </div>
          </div>
          <div class="mobileNavBox">
            <div class="mobileNavInfo"
                 v-for="(item,index) in menuData.menuList[menuData.menuIndex]['data'][menuData.childIndex]['data']"
                 :key="index"
                 @click.stop="handleMSun(index,item)">
              <div class="mNavInfo">{{ item.name }}</div>
              <el-image :src="m_right_icon" class="m_right_icon"></el-image>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>

  <!--  在线申请-->
  <onlineApplication ref="onlineApplicationRef"></onlineApplication>
</template>

<script setup>
//菜单栏------------------------------
import {defineEmits, defineExpose, defineProps, onMounted, reactive, ref} from "vue";
import router from "@/router";
import {
  AdaptationScreen,
  appointmentLoan,
  fileUrl,
  loanAppointmentJumpConnection,
  wxAppLink
} from "@/common/js/config.default"
import {ElMessage} from "element-plus";

import {eventBus} from "@/store/eventBus";
import {clickMonitor} from "@/common/js/tools";
import {informationInfo} from "@/http/publicityInformation/servicePricePublicity";
import {getBrandList} from "@/http/financialService/financialCalculation";
import {systemConfigList} from "@/http/sys";

const innerHeight = window.innerHeight;

const props = defineProps({
  logoIndex: {
    type: String,
    default: 0
  },
  maskHeight: {
    type: String,
    default: 720
  },
  doesTheHeadChange: {
    type: Boolean,
    default: true
  },
  isShowOperation: {
    type: Boolean,
    default: true
  },
  financialCalculationIconsFlag: {
    type: Boolean,
    default: true
  },
})
const screenType = ref('pc');

const brandFinancialLogo = ref("");

let financialCalculationIconsState = ref(false);
let financialCalculationIconsIndex = ref("");
const position = ref('absolute');

const emit = defineEmits(['handleBackToTheBottom', "handleFinancialCalculationIcon", "handleFinancialCalculationIndex"])

const closeIcon = require("@/assets/components/headerMenu/close.png");
const m_left_icon = require("@/assets/components/headerMenu/H5/left_icon.png");
const m_close_icon = require("@/assets/components/headerMenu/H5/close_icon.png");
const m_right_icon = require("@/assets/components/headerMenu/H5/right_icon.png");
const m_down_icon = require("@/assets/components/headerMenu/H5/down_icon.png");
const m_menu_icon = require("@/assets/components/headerMenu/H5/menu.png");

const contentImageUrl = ref("");
const contentMobileImageUrl = ref("");

const mFlag = ref(false);
const headerMenuData = ref([]);
const menuData = reactive({
  background: 'transparent',
  menuIcon: require('@/assets/home/menu.png'),
  logoList: [require('@/assets/home/logo.png'), require('@/assets/home/logo2.png'), require('@/assets/home/logo3.png')],
  financialCalculationIcons: [
    require('@/assets/components/headerMenu/0.png'),
    require('@/assets/components/headerMenu/1.png'),
    require('@/assets/components/headerMenu/2.png'),
    require('@/assets/components/headerMenu/3.png'),
    require('@/assets/components/headerMenu/4.png'),
    require('@/assets/components/headerMenu/5.png'),
    require('@/assets/components/headerMenu/6.png'),
    require('@/assets/components/headerMenu/7.png'),],
  arrow: require('@/assets/home/arrow.png'),
  menuFlag: false,
  menuIndex: 0,
  childFlag: false,
  childIndex: 0,
  sunFlag: false,
  sunIndex: 0,
  menuList: [
    {
      name: '首页',
      path: '/',
      active: true,
      data: [],
    },
    {
      name: '最新活动',
      path: '/',
      active: false,
      data: []
    },
    {
      name: '金融服务',
      path: '/',
      active: false,
      top: 135,
      data: [
        {
          name: '金融测算',
          top: 135,
          data: [
            {
              name: '玛莎拉蒂',
              brandName: "玛莎拉蒂",
              active: false,
              //link: "https://www.maserati.com/cn/zh"
              link: "/financialServices/financialCalculation",
              show: true,
              query: {
                financialIndex: 0,
                financialCalculationIconsState: true,
                title: "玛莎拉蒂"
              }
            },
            {
              name: '阿尔法罗密欧',
              brandName: "阿尔法罗密欧",
              active: false,
              //link: "https://www.alfaromeo.cn/"
              link: "/financialServices/financialCalculation",
              show: true,
              query: {
                financialIndex: 1,
                financialCalculationIconsState: true,
                title: "阿尔法罗密欧"
              }
            },
            {
              name: '标致',
              brandName: "标致",
              active: false,
              //link: "https://www.peugeot.com.cn/"
              link: "/financialServices/financialCalculation",
              show: true,
              query: {
                financialIndex: 2,
                financialCalculationIconsState: true,
                title: "标致"
              }
            },
            {
              name: "Jeep",
              brandName: "Jeep",
              active: false,
              //link: "https://www.jeep.com.cn/not-found"
              link: "/financialServices/financialCalculation",
              show: true,
              query: {
                financialIndex: 3,
                financialCalculationIconsState: true,
                title: "Jeep"
              }
            },
            {
              name: "依维柯",
              brandName: "依维柯",
              active: false,
              //link: "https://www.naveco.com.cn/home.php"
              link: "/financialServices/financialCalculation",
              show: true,
              query: {
                financialIndex: 4,
                financialCalculationIconsState: true,
                title: "依维柯"
              }
            },
            //{
            //  name: 'DS',
            //  brandName: "DS",
            //  active: false,
            //  //link: "https://www.ds.com.cn/ds-web/"
            //  link: "/financialServices/financialCalculation",
            //  show: true,
            //  query: {
            //    financialIndex: 5,
            //    financialCalculationIconsState: true,
            //    title: "DS"
            //  }
            //},
            {
              name: "迈凯伦",
              brandName: "迈凯伦",
              active: false,
              //link: "https://www.mclarencars.cn/"
              link: "/financialServices/financialCalculation",
              show: true,
              query: {
                financialIndex: 6,
                financialCalculationIconsState: true,
                title: "迈凯伦"
              }
            },
            //{
            //  name: "法拉利",
            //  brandName: "法拉利",
            //  active: false,
            //  link: "/financialServices/financialCalculation",
            //  show: false,
            //  query: {
            //    financialIndex: 7,
            //    financialCalculationIconsState: true,
            //  }
            //}
          ],
          active: false
        },
        {
          name: "金融产品",
          active: false,
          data: [],
          link: "/financialServices/financialProducts"
        },
        {
          name: '车贷指南',
          active: false,
          data: [],
          link: "/financialServices/carLoanGuidelines"
        },
        {
          name: '贷款预约',
          active: false,
          top: 230,
          data: loanAppointmentJumpConnection,
          link: appointmentLoan
        },
        {
          name: '其他服务',
          active: false,
          top: 260,
          data: [
            {
              name: "大客户服务",
              active: false,
              link: "/bigHome"
            },
            {
              name: "售后回租",
              active: false,
              link: ""
            }
          ]
        }
      ]
    },
    {
      name: '公示信息',
      path: '/',
      active: false,
      top: 185,
      data: [
        {
          name: '信息披露',
          active: false,
          link: "/publicityInformation/informationDisclosure",
          type: "",
          data: []
        },
        {
          name: '服务价格公示',
          active: false,
          data: [],
          link: "/publicityInformation/servicePricePublicity",
          type: "",
        },
        {
          name: '金融许可证公告',
          active: false,
          data: [],
          link: "",
          type: "open",
        },
        {
          name: '营业执照',
          active: false,
          data: [],
          link: "",
          type: "open",
        },
        {
          name: '金融知识宣传',
          active: false,
          data: [],
          link: "/latestActivity/activity1",
          type: "",
          query: {
            activeIndex: 4
          },
        },
        {
          name: '汽车金融业务合同模版',
          active: false,
          data: [],
          link: "/publicityInformation/contractTemplate",
          type: "",
        },
        {
          name: '投诉及征信异议受理渠道及流程',
          active: false,
          data: [],
          link: "/publicityInformation/complaintAcceptance",
          type: "",
        },
      ]
    },
    {
      name: '关于我们',
      path: '/',
      active: false,
      top: 220,
      data: [
        {
          name: '公司介绍',
          link: "/aboutUs/publicityIntroduction",
          query: {},
          data: [],
        },
        {
          name: '门店查询',
          link: "/aboutUs/dealerQuery",
          query: {},
          data: [],
        },
        {
          name: '联系我们',
          link: "/",
          query: {
            backToTheBottom: true
          },
          data: []
        },
        {
          name: '客户留言',
          link: "/aboutUs/customerMessage",
          query: {},
          data: []
        },
      ]
    },
  ]
})

const onlineApplicationRef = ref(null);

//改变背景色
const handleChangeBgColor = (color) => {
  menuData.background = color;
}

const handleOpenMenu = () => {
  console.log('打开菜单');
  menuData.menuFlag = true
  if (screenType.value === 'mobile') {
    mFlag.value = true;
  }
}

const handleSelectMenu = (index) => {
  menuData.menuList.forEach((item, index) => {
    item.active = false
  })
  menuData.menuList[index].active = true
  //menuData.menuFlag = false

  if (index === 0) {
    menuData.menuFlag = false;
    router.push({path: '/'})
  } else if (index === 1) {
    router.push({path: '/latestActivity/activity1'})
  } else if (index === 3) {
    router.push({path: '/publicityInformation/pInformation'})
  } else {
    menuData.childFlag = true
    menuData.menuIndex = index;
  }

}

const handleMenuMouseOver = (index) => {
  // console.log("父菜单---", index);
  // menuData.menuList.forEach((item, index) => {
  //   item.active = false
  // })
  // menuData.menuList[index].active = true;
  // console.log("父菜单---", index);
  //
  // if (index === 0) {
  // } else if (index === 1) {
  // } else if (index === 3) {
  // } else {
  //   menuData.childFlag = true
  //   menuData.menuIndex = index;
  // }

  menuData.menuList.forEach((item, index) => {
    item.active = false
  })
  menuData.menuList[index].active = true
  //menuData.menuFlag = false
  menuData.menuIndex = index;
  if (index === 2 || index === 3 || index === 4) {
    menuData.childFlag = true
  } else {
    menuData.childFlag = false
  }

  menuData.sunFlag = false;

}

const handleMenuLeave = () => {

}

const handleChildMenuClick = (index, item) => {
  // console.log("子菜单---", index);
  menuData.childIndex = index;
  menuData.menuList[menuData.menuIndex].data.forEach((item, index) => {
    item.active = false
  })
  menuData.menuList[menuData.menuIndex].data[index].active = true
  menuData.sunFlag = true

  menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data.forEach((item, index) => {
    item.active = false
  })

  if (menuData.menuList[menuData.menuIndex].data[index].name === '贷款预约') {
    //window.open(menuData.menuList[menuData.menuIndex].data[index].link)
  } else {
    if (item?.type === 'open') {
      window.open(item.link)
    } else {
      router.push({
        path: menuData.menuList[menuData.menuIndex].data[index].link,
        query: menuData.menuList[menuData.menuIndex].data[index].query
      })
    }

  }

  if (menuData.menuList[menuData.menuIndex].data[index].name === '联系我们') {
    handleBackToTheBottom()
    handleGoBack();
    menuData.menuFlag = false;
  }

}

const handleChildMenuLeave = () => {
  if (menuData.sunFlag) {
    menuData.childFlag = true
  } else {
    menuData.childFlag = false;
  }

}

const handleChildMenuMouseOver = index => {
  // console.log(index);
  // menuData.menuList[menuData.menuIndex].data.forEach((item, index) => {
  //   item.active = false
  // })
  //
  // menuData.menuList[menuData.menuIndex].data[index].active = true;
  // menuData.sunFlag = true

  menuData.childIndex = index;
  menuData.menuList[menuData.menuIndex].data.forEach((item, index) => {
    item.active = false
  })
  menuData.menuList[menuData.menuIndex].data[index].active = true
  if (index === 0 || index === 3 || index === 4) {
    menuData.sunFlag = true
  } else {
    menuData.sunFlag = false
  }

  menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data.forEach((item, index) => {
    item.active = false
  })

}

const handleSunMouseOver = () => {
  //menuData.childFlag = true;
}

const handleSunMouseLeave = () => {

  menuData.sunFlag = false;
}

const handleSunMenuMouseOver = (index, item) => {
  //console.log("孙子---", index);
  menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data.forEach((item, index) => {
    item.active = false
  })
  menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data[index].active = true

  //window.open(menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data[index].link)
  if (menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data[index].link === "") {
    ElMessage.info('敬请期待');
  } else {

    if (menuData.menuList[menuData.menuIndex].data[menuData.childIndex].name === '贷款预约') {
      //if (menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data[index]?.noData) {
      //  return ElMessage({
      //    message: "敬请期待",
      //    type: "warning"
      //  })
      //}
      //window.open(menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data[index].link)

      handleFinancialCalculationIcon(item.query.financialIndex, item)

      let params = {
        ...menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data[index].query,
        source:1,// "留资-官网"
      }

      window.localStorage.setItem("brandFinancialLogo",menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data[index].query.brandFinancialLogo)

      delete menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data[index].query.brandFinancialLogo

      router.push({
        path: menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data[index].link,
        query: params
      })
    } else {
      if (menuData.menuList[menuData.menuIndex].data[menuData.childIndex].name === '金融测算') {

        if (item.brandName === '迈凯伦') {
          handleFinancialCalculationIcon(index + 1, item)
        } else {
          handleFinancialCalculationIcon(index, item)
        }

      }

      window.localStorage.setItem("brandFinancialLogo",menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data[index].query.brandFinancialLogo)

      delete menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data[index].query.brandFinancialLogo

      router.push({
        path: menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data[index].link,
        query: menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data[index].query
      })
    }

  }

}

const handleGoBack = () => {
  menuData.childFlag = false;
  menuData.sunFlag = false;
  menuData.menuFlag = true;

}

const handleHideMask = () => {
  menuData.childFlag = false;
  menuData.sunFlag = false;
  menuData.menuFlag = false;
}

const handleOnlineApply = () => {
  onlineApplicationRef.value.openMask(0, false);

  clickMonitor({
    event_en: "topOnlineApplication",
    event_cn: "顶部-在线申请",
  })
}

const handleMobileOnlineApply = () => {
  window.open(wxAppLink)
}

const handleLoanCalculation = () => {
  router.push({path: '/', query: {financialIndex: 0}})
  handleFinancialCalculation();

  clickMonitor({
    event_en: "topLoanCalculation",
    event_cn: "顶部-贷款测算",
  })
}

const handleFinancialCalculation = () => {
  emit('handleFinancialCalculation', true)
}

const handleBackToTheBottom = () => {
  emit('handleBackToTheBottom', true)
}

const handleBackHome = () => {
  router.push({path: '/'})
}

const initIcon = (index = 0) => {
  financialCalculationIconsState.value = true;
  financialCalculationIconsIndex.value = index;
  if (headerMenuData.value.length > 0) {

    let findIndex = loanAppointmentJumpConnection.findIndex(item => Number(item.query.financialIndex) === Number(index));
    //console.log(findIndex, "==findIndex==");
    let mindex = headerMenuData.value.findIndex(item => item.brandName === loanAppointmentJumpConnection[findIndex].brandName);
    //console.log(mindex, "==mindex==");
    handleBrandFinancialLogo(screenType.value === 'pc' ? headerMenuData.value[mindex].brandFinancialLogo : headerMenuData.value[mindex].brandFinancialMobileLogo);
  } else {
    getLogoListFn(() => {
      let findIndex = loanAppointmentJumpConnection.findIndex(item => Number(item.query.financialIndex) === Number(index));
      let mindex = headerMenuData.value.findIndex(item => item.brandName === loanAppointmentJumpConnection[findIndex].brandName);
      handleBrandFinancialLogo(screenType.value === 'pc' ? headerMenuData.value[mindex].brandFinancialLogo : headerMenuData.value[mindex].brandFinancialMobileLogo);
    })
  }
}

const handleFinancialCalculationIcon = (index = 0, item = {}) => {
  initIcon(index);
  //emit("handleFinancialCalculationIcon", index)
  emit("handleFinancialCalculationIndex", {
    index,
    item
  })
}

const handleChangePosition = (style) => {
  position.value = style;
}

//公示信息
const publicityInformation = () => {
  informationInfo({
    moduleType: 'jrxkzgg'
  }).then(res => {
    if (res.code === 200) {
      let findIndex = menuData.menuList.findIndex(item => item.name === '公示信息')
      let findChildIndex = menuData.menuList[findIndex].data.findIndex(item => item.name === '金融许可证公告')
      menuData.menuList[findIndex].data[findChildIndex].link = fileUrl + res.data[0].fileUrl
    }
  })
  informationInfo({
    moduleType: 'yyzz'
  }).then(res => {
    if (res.code === 200) {
      let findIndex = menuData.menuList.findIndex(item => item.name === '公示信息')
      let findChildIndex = menuData.menuList[findIndex].data.findIndex(item => item.name === '营业执照')
      menuData.menuList[findIndex].data[findChildIndex].link = fileUrl + res.data[0].fileUrl
    }
  })
}

const handleMPrev = () => {
  //menuData.menuFlag = true;
  //menuData.childFlag = false;
  //menuData.menuList[menuData.menuIndex].data.forEach((item, index) => {
  //  item.active = false
  //})

  menuData.childFlag = false;

}

const handleMSunPrev = () => {
  menuData.sunFlag = false;
}

const handleMClose = () => {
  menuData.menuFlag = false;
  menuData.childFlag = false;
  menuData.sunFlag = false;
  mFlag.value = false;

  //mFlag.value = false;
  //menuData.menuFlag = false;
  //menuData.childFlag = false;
  //menuData.menuList[menuData.menuIndex].data.forEach((item, index) => {
  //  item.active = false
  //})
}

const handleMParent = (index, item) => {
  //menuData.menuFlag = false;
  menuData.menuList.forEach((item, cIndex) => {
    item.active = false
  })
  menuData.menuList[index].active = true

  if (index === 0) {
    router.push({path: '/'})
  } else if (index === 1) {
    router.push({path: '/latestActivity/activity1'})
    handleMClose();
  } else if (index === 3) {
    router.push({path: '/publicityInformation/pInformation'})
    handleMClose();
  } else {
    menuData.childFlag = true;
    menuData.menuIndex = index;
  }

}

const handleMChild = (index, item) => {
  console.log(item);
  menuData.childIndex = index;
  menuData.menuList[menuData.menuIndex].data.forEach((item, cIndex) => {
    if (cIndex === index) {
      item.active = !item.active
    } else {
      item.active = false
    }
  })
  //menuData.menuList[menuData.menuIndex].data[index].active = true
  menuData.sunFlag = true;

  if (item.data.length > 0) {

  } else {
    if (item?.type === 'open') {
      window.open(item.link)
    } else {
      router.push({
        path: menuData.menuList[menuData.menuIndex].data[index].link,
        query: menuData.menuList[menuData.menuIndex].data[index].query
      })
    }
    handleMClose();
  }

  if (menuData.menuList[menuData.menuIndex].data[index].name === '联系我们') {
    handleBackToTheBottom()
    handleGoBack();
    menuData.menuFlag = false;
    handleMClose();
  }

}

const handleMSun = (index, item) => {
  menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data.forEach((item, index) => {
    item.active = false
  })

  if (menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data[index].link === "") {
    ElMessage({
      customClass: screenType.value === 'pc' ? '' : 'messageBox',
      message: "敬请期待",
      type: "info"
    })
  } else {
    if (menuData.menuList[menuData.menuIndex].data[menuData.childIndex].name === '贷款预约') {

      //handleFinancialCalculationIcon(item.query.financialIndex, item)

      let params = {
        ...menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data[index].query,
        source: 1,//"留资-官网"
      }

      router.push({
        path: menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data[index].link,
        query: params
      })
    } else {
      if (menuData.menuList[menuData.menuIndex].data[menuData.childIndex].name === '金融测算') {
        if (item.brandName === '迈凯伦') {
          handleFinancialCalculationIcon(index + 1, item)
        } else {
          handleFinancialCalculationIcon(index, item)
        }

      }
      router.push({
        path: menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data[index].link,
        query: menuData.menuList[menuData.menuIndex].data[menuData.childIndex].data[index].query
      })
    }

    handleMClose();
  }
}

const handleBrandFinancialLogo = (img) => {
  //console.log("img-----", img);
  //brandFinancialLogo.value = "";
  //setTimeout(() => {
  //  brandFinancialLogo.value = img;
  //
  //}, 300)

  brandFinancialLogo.value = img;

}

const getBrandListFn = async () => {
  let res = await getBrandList();
  if (res.code === 200) {
    let findModelIndex = menuData.menuList.findIndex(item => item.name === '金融服务');
    menuData.menuList[findModelIndex].data[0].data.forEach((item, index) => {
      res.data.forEach((item2, index2) => {
        if (item.brandName === item2.brandName) {
          item.query.id = item2.id;
          item.query.brandFinancialLogo = item2.brandFinancialLogo;
        }
      })
    })

  }
}

//获取系统配置列表
const getSysteConfigList = async () => {
  let res = await systemConfigList({
    type: "headerMenu"
  });
  if (res.code === 200) {
    //console.log(res.data);
    contentImageUrl.value = res.data[0].contentImageUrl;
    contentMobileImageUrl.value = res.data[0].contentMobileImageUrl;
  }
}

const getLogoListFn = async (cb) => {
  let res = await getBrandList();
  if (res.code === 200) {
    headerMenuData.value = res.data;
    cb && cb();
  }
}

defineExpose({
  handleChangeBgColor,
  initIcon,
  handleFinancialCalculationIcon,
  handleChangePosition,
  handleBrandFinancialLogo
})

onMounted(() => {
  if (router.currentRoute.value.path === '/financialServices/financialCalculation' && router.currentRoute.value.path === '/aboutUs/loanAppointment') {
    getLogoListFn();
  } else {
    getSysteConfigList();
  }
  getBrandListFn();

  eventBus.on("financialIndex", (financialIndex) => {
    handleFinancialCalculationIcon(financialIndex)
  })

  AdaptationScreen(() => {
    console.log('H5');
    if (props.doesTheHeadChange) {
      screenType.value = 'mobile'
      menuData.logoList[props.logoIndex] = require("@/assets/components/headerMenu/H5/logo.png")
    } else {
      screenType.value = 'pc'
    }

    console.log('H5', screenType.value);
  }, () => {
    screenType.value = 'pc'
    menuData.logoList = [require('@/assets/home/logo.png'), require('@/assets/home/logo2.png'), require('@/assets/home/logo3.png')]
  })

  publicityInformation();

})
</script>

<style scoped lang="scss">
@import "@/common/scss/breakpoints";
@import "@/common/scss/common.scss";


.menuBox {
  width: 100%;
  height: 100px;
  //position: fixed;
  top: 0;
  z-index: 10000;
  transition: all 0.5s;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .leftBox {
    width: 25%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;

    .menuIcon {
      width: 28px;
      height: 24px;
      //position: absolute;
      //top: 50%;
      //left: 45px;
      //transform: translateY(-50%);
      cursor: pointer;
      margin-left: 45px;

    }

    .menuTip {
      font-size: 15px;
      color: #fff;
      margin-left: 17px;
      cursor: pointer;
      //position: absolute;
      //top: 50%;
      //left: 90px;
      //transform: translateY(-50%);
    }
  }

  .middleBox {
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .menuLogo {
      width: 671px;
      height: 63px;
      cursor: pointer;
    }

    .menuLogo0 {
      width: 196px;
      height: 42px;
      //position: absolute;
      //top: 50%;
      //left: 50%;
      //transform: translate(-50%, -50%);
      cursor: pointer;
    }

    .menuLogo1 {
      width: 671px;
      height: 63px;
      //position: absolute;
      //top: 50%;
      //left: 50%;
      //transform: translate(-50%, -50%);
      cursor: pointer;
    }

    .menuLogo2 {
      width: 111px;
      height: 111px;
      //position: absolute;
      //top: 50%;
      //left: 50%;
      //transform: translate(-50%, -50%);
      cursor: pointer;
    }

    .financialCalculationIcons {
      //position: absolute;
      //top: 50%;
      //left: 50%;
      //transform: translate(-50%, -50%);
      cursor: pointer;
      //opacity: 0;


      &.financialCalculationIcons0 {
        width: 111px;
        height: 111px;
      }

      &.financialCalculationIcons1 {
        width: 109px;
        height: 80px;
      }

      &.financialCalculationIcons2 {
        width: 103px;
        height: 80px;
      }

      &.financialCalculationIcons3 {
        width: 315px;
        height: 42px;
      }

      &.financialCalculationIcons4 {
        width: 671px;
        height: 63px;
      }

      &.financialCalculationIcons5 {
        width: 343px;
        height: 81px;
      }

      &.financialCalculationIcons6 {
        //width: 671px;
        //height: 63px;

        width: 141px;
        height: 70px;
      }

      &.financialCalculationIcons7 {
        width: 671px;
        height: 63px;
      }
    }
  }

  .rightBox {
    width: 25%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .menuOpeartion {
      width: 175px;
      height: 40px;
      background: #004393;
      display: flex;
      justify-content: center;
      align-items: center;
      //position: absolute;
      //top: 50%;
      //right: 45px;
      //transform: translateY(-50%);
      color: #fff;
      font-size: 15px;
      border-radius: 5px;
      cursor: pointer;

      &.menuOpeartion1 {
        border: 1px solid #FFFFFF;
        color: #FFFFFF;
        background: transparent;
        margin-right: 30px;
      }
    }
  }


}

.menuMaskBigContainer {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  transition: all 0.5s;

  .menuMaskContainer {
    width: 350px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    background: #2B2B2B;

    .menuMaskBox {
      width: 290px;
      height: auto;
      position: absolute;
      top: 80px;
      left: 50%;
      transform: translateX(-50%);

      .menuMc {
        width: 100%;
        height: 45px;
        position: relative;
        margin-bottom: 16px;
        border-radius: 5px;
        cursor: pointer;

        &.menuMc1 {
          background: #004393;
        }


        .menuInfo {
          width: 100%;
          height: 45px;
          display: flex;
          align-items: center;
          font-size: 20px;
          color: #fff;
          padding: 0 18px;
          box-sizing: border-box;
        }

        .arrow {
          width: 9px;
          height: 15px;
          position: absolute;
          top: 50%;
          right: 18px;
          transform: translateY(-50%);
        }
      }


    }

    .closeIcon {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 30px;
      right: 26px;
      cursor: pointer;
    }
  }
}

.childMaskContainer {
  width: 350px;
  height: auto;
  padding: 10px 0;
  background: #2B2B2B;
  position: fixed;
  left: 350px;
  z-index: 10000;

  .childInfoBox {
    width: 90%;
    height: 45px;
    cursor: pointer;
    transition: all 0.5s;
    margin: 0 auto;
    border-radius: 5px;

    &.active {
      background: #004393;
    }

    .cBox {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;

      .childInfo {
        font-size: 20px;
        color: #fff;
      }

      .arrow {
        width: 9px;
        height: 15px;
      }
    }

  }
}

.sunMaskContainer {
  width: 350px;
  height: auto;
  padding: 10px 0;
  background: #2B2B2B;
  position: fixed;
  left: 700px;
  z-index: 10000;

  &.pT {
    padding: 10px 0;
  }

  &.pNone {
    padding: 0;
  }

  .sunInfoBox {
    width: 90%;
    height: 45px;
    cursor: pointer;
    transition: all 0.5s;
    margin: 0 auto;
    border-radius: 5px;

    &:hover {
      background: #004393;
    }

    //&.active {
    //  background: #004393;
    //}

    .sBox {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;

      .sunInfo {
        font-size: 20px;
        color: #fff;
      }

      .arrow {
        width: 9px;
        height: 15px;
      }
    }

  }
}


//.childrenBigMenuContainer {
//  width: 100%;
//  height: 100%;
//  position: fixed;
//  top: 0;
//  left: 0;
//  z-index: 999;
//  transition: all 0.5s;
//
//  .childrenMenuContainer {
//    width: 350px;
//    height: 100%;
//    position: absolute;
//    top: 0;
//    left: 0;
//    z-index: 999;
//    background: #2B2B2B;
//
//    .childrenBigTitle {
//      width: 100%;
//      font-size: 20px;
//      color: #fff;
//      padding-left: 34px;
//      box-sizing: border-box;
//      margin-top: 39px;
//      letter-spacing: 2px;
//      cursor: pointer;
//    }
//
//    .childrenMenuMaskBox {
//      width: 290px;
//      height: auto;
//      position: absolute;
//      top: 100px;
//      left: 50%;
//      transform: translateX(-50%);
//
//      .childrenSmallTitle {
//        width: 100%;
//        height: 45px;
//        display: flex;
//        align-items: center;
//        justify-content: space-between;
//        padding: 0 18px;
//        box-sizing: border-box;
//        cursor: pointer;
//        border-radius: 5px;
//        margin-bottom: 20px;
//
//        &:hover {
//          background: #004393;
//        }
//
//        &.active {
//          background: #004393;
//        }
//
//        .cTitle {
//          font-size: 18px;
//          color: #fff;
//        }
//      }
//    }
//  }
//
//  .closeIcon {
//    width: 20px;
//    height: 20px;
//    position: absolute;
//    top: 40px;
//    right: 26px;
//    cursor: pointer;
//  }
//}
//
//.sunTzuBigMenuContainer {
//  width: 100%;
//  position: fixed;
//  top: 0;
//  left: 0;
//  z-index: 999;
//  transition: all 0.5s;
//
//  .sunTzuMenuContainer {
//    width: 300px;
//    height: auto;
//    position: absolute;
//    top: 128px;
//    left: 350px;
//    background: #1D1D1D;
//    border-radius: 15px;
//    z-index: 5;
//    padding: 13px 23px 20px 23px;
//
//    .sBox {
//      width: 253px;
//      height: auto;
//
//      .sunTitleBox {
//        width: 253px;
//        height: 31px;
//        border-radius: 5px;
//        font-size: 18px;
//        padding-left: 20px;
//        box-sizing: border-box;
//        display: flex;
//        align-items: center;
//        color: #fff;
//        cursor: pointer;
//        letter-spacing: 2px;
//
//        &:hover {
//          background: #4A4A4A;
//        }
//      }
//
//      .sunLine {
//        width: 100%;
//        height: 1px;
//        background: #fff;
//        margin-top: 8px;
//        margin-bottom: 8px;
//      }
//    }
//  }
//}

.fadeIn {
  animation-duration: 0.5s;
}

@include media-breakpoint-up("md") {
  @import "./index-md.scss";
}
</style>
